import { Unstable_Grid2 as Grid } from '@mui/material';
import { useMemo } from 'react';

import { ChipLinkBox, InfoField, CardLayout } from '@occc/ui-design-system';
import { ContainerColumnLeft } from '@occc-app/design-system';

import { titleByCombinedAudiencesOperator } from './constants';

import { CombinedAudiencesAttribute } from '../../types';
import { routeCreator } from '../../utils';

export type CombinedAudiencesDetailsProps = {
  combinedAudiences: CombinedAudiencesAttribute;
};

export const CombinedAudiencesDetails = ({ combinedAudiences }: CombinedAudiencesDetailsProps) => {
  const audienceChipItems = useMemo(
    () =>
      combinedAudiences.audiences.map((audience) => {
        return {
          label: audience.name,
          href: routeCreator.details(audience.uuid),
        };
      }),
    [combinedAudiences.audiences],
  );

  return (
    <ContainerColumnLeft>
      <CardLayout title='Combined Audiences'>
        <Grid container spacing={3}>
          <Grid xs={12} sm={6} md={3}>
            <InfoField
              label='Members are in'
              value={
                combinedAudiences.operator
                  ? titleByCombinedAudiencesOperator[combinedAudiences.operator]
                  : undefined
              }
            />
          </Grid>

          <Grid xs>
            <InfoField label='Audiences' value={<ChipLinkBox items={audienceChipItems} />} />
          </Grid>
        </Grid>
      </CardLayout>
    </ContainerColumnLeft>
  );
};
